import Vue from 'vue'
import Dialog from 'vue-dialog-loading'

//global config
export default Vue.use(Dialog, {
  dialogBtnColor: '#0f0',
  background: 'rgba(0, 0, 0, 0.5)'
})
